import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Container, Row, Col } from 'react-bootstrap';
import Skeleton from '../../components/skeleton/Skeleton';
import sectionGreenBg from '../../assets/images/section-banner.webp';
import wrapCenterBg from '../../assets/images/wrap-center.webp';
import { SanitizedHTML } from '../../utils/Helper';
import { API_ENDPOINTS } from '../../utils/config';

const pageId = 3;
const config = {
    headers:{
        'Content-type': 'application/json; charset=UTF-8'
    }
};

/**
 * Renders a mailto hyperlink.
 * @param {Object} props
 * @param {string} props.email
 * @param {string} [props.subject]
 * @param {string} [props.body]
 * @param {React.ReactNode} props.children
 */
const Mailto = ({ email, subject = '', body = '', children }) => (
     <a className="text-dark" href={`mailto:${email}?subject=${subject}&body=${body}`}>
        {children}
    </a>
);

const AboutSection = () => {
    const [isLoading, setIsLoading] = useState(true); 
    const [content, setContent] = useState({
        id: null,
        title: '',
        content: '',
        emailAddress: '',
        dateOfBirth: '',
        place: '',
        phoneNumber: '',
        yearsOfExperience: '',
    }); 

    useEffect(() => {
        const fetchPageContent = async () => {
            setIsLoading( true );

            try {
                const response = await axios.get( `${API_ENDPOINTS.PAGE_ENDPOINT}${pageId}`, config );
                setContent({
                    id: response.data.id,
                    title: response.data.full_name,
                    content: response.data.content,
                    emailAddress: response.data.email_address,
                    dateOfBirth: response.data.date_of_birth,
                    place: response.data.place,
                    phoneNumber: response.data.phone_number,
                    yearsOfExperience: response.data.years_of_experience,

                })
                setIsLoading( false );
            } catch ( error ) {
                console.error( error );
            } finally {
                setIsLoading( false );
            }
        };

        fetchPageContent();
        // eslint-disable-next-line	
    },[])

    const renderContent = () => (
        <>             
            <Row>
                <div className="col-lg-8 text-center text-lg-start wow fadeInUp">
                    <h2 className="text-8 fw-400 mb-3">Hi, I'm <span className="fw-600 border-bottom border-3 border-secondary text-dark">{ content.title }</span></h2>
                    <SanitizedHTML className="text-3" html={ content.content } tag="div" />
                </div>
                <Col className="col-lg-4 mt-4 mt-lg-0 wow fadeInUp" data-wow-delay="0.2s">
                    <div className="featured-box style-4">
                        <div className="featured-box-icon text-25 fw-500 bg-secondary rounded-circle">
                            <span className="wow heartBeat" data-wow-delay="1.3s">{ content.yearsOfExperience }</span>
                        </div>
                        <h3 className="text-7 wow rubberBand" data-wow-delay="2s">Years of <span className="fw-700">Experience</span></h3>
                    </div>
                </Col>
            </Row>
            <Row className="gy-3 mt-4">
                <Col className="col-12 col-sm-6 col-lg-3 wow fadeInUp">
                    <p className="text-muted fw-500 mb-0">Phone:</p>
                    <p className="text-3 text-dark fw-600 mb-0">{ content.phoneNumber }</p>
                </Col>
                <Col className="col-12 col-sm-6 col-lg-3 wow fadeInUp" data-wow-delay="0.2s">
                    <p className="text-muted fw-500 mb-0">Email:</p>
                    <p className="text-3 fw-600 mb-0"><Mailto email={ content.emailAddress } subject="Hello" body="Hello Jinesh P.V">{ content.emailAddress }</Mailto></p>
                </Col>
                <Col className="col-12 col-sm-6 col-lg-3 wow fadeInUp" data-wow-delay="0.3s">
                    <p className="text-muted fw-500 mb-0">Date of birth:</p>
                    <p className="text-3 text-dark fw-600 mb-0">{ content.dateOfBirth }</p>
                </Col>
                <Col className="col-12 col-sm-6 col-lg-3 wow fadeInUp" data-wow-delay="0.4s">
                    <p className="text-muted fw-500 mb-0">From:</p>
                    <p className="text-3 text-dark fw-600 mb-0">{ content.place }</p>
                </Col>
            </Row>
        </>
    );

    return (
        <section
            id="about" 
            className="section" 
            style={{ background: `url(${ wrapCenterBg }), linear-gradient(0deg,rgba(255,255,255,.19),rgba(255,255,255,.19)),linear-gradient(241.46deg,#b8ffe3 -.94%,#bef7bd 90.04%)` }}
        >
            <div 
                className="section-decoration top" 
                style={{ backgroundImage: `url(${ sectionGreenBg })`, height: '35px' }}
            />          
            <Container> 
                <div className="position-relative d-flex text-center mb-5">
                    <h2 
                    id="about-title"
                    className="text-22 text-light opacity-4 text-uppercase fw-600 w-100 mb-0 font-primary wow fadeInUp"
                    >
                        About Me
                    </h2>
                        <p className="text-10 text-dark fw-600 position-absolute w-100 align-self-center font-secondary lh-base mb-0 wow fadeInUp"
                    >
                        Know Me More
                    </p>
                </div> 
                { isLoading ? <Skeleton type="about" /> : renderContent() }
            </Container>
        </section>
    );
};

export default AboutSection